import {PIXI} from '@colonist/pixi'
import {HighlightableSpriteView} from './HighlightableSpriteView'
import {GameFont} from '../GameFont'
import {SectionView} from './SectionView'
import {TextView} from './TextView'
import {TranslationObject} from '@colonist/i18n'

export class ItemCountView extends SectionView {
    readonly view: HighlightableSpriteView
    readonly count: TextView

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, texture: PIXI.Texture,
                textX: number, textY: number, textW: number, textH: number, iconPadding: number,
                textSize: GameFont.Size = GameFont.Size.L, textColor?: string) {
        const removePadding = true
        super(x, y, w, h, container, removePadding)

        this.view = new HighlightableSpriteView(x, y, w, h, texture, container, iconPadding)

        this.count = new TextView({key: 'strings:colonistCommon.utils.#buffer', options: {value: 0}}, textX, textY, textW, textH, container, textSize, textColor)
        this.count.repositionY(false)
        this.count.centerX()
    }

    updateText(text: TranslationObject) {
        this.count.setText(text)
        this.count.centerX()
    }

    resetTextYPosition() {
        this.count.repositionY(true)
    }

    showView(parent: PIXI.Container) {
        this.view.showView(parent)
        if(this.count.parent == undefined) parent.addChild(this.count)
    }

    hideView() {
        this.view.hideView()
        if(this.count.parent != undefined) this.count.parent.removeChild(this.count)
    }

    toggleView(parent: PIXI.Container) {
        const isHidden = this.view.parent == undefined
        isHidden ? this.showView(parent) : this.hideView()
    }

    destroy() {
        super.destroy()
        this.view.destroy()
        this.count.destroy()
    }
}
